import type { ReportImpiantoPaginationDTO } from '@/models/dto/report/report-impianto-pagination-dto'
import type { FacilityReportsWithPagination } from '@/models/types/report/facility-reports-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToFacilityReport, mapToReportImpiantoDTO } from './facility-report-mapper'

const mapToReportImpiantiDTO = (reports: FacilityReportsWithPagination): ReportImpiantoPaginationDTO => {
    return {
        reportImpianti: reports.reports?.map((report) => mapToReportImpiantoDTO(report)),
        paginationData: reports.pagination ? mapToPaginationDTO(reports.pagination) : null,
    }
}

const mapToFacilityReports = (dto: ReportImpiantoPaginationDTO): FacilityReportsWithPagination => {
    return {
        reports: dto.reportImpianti?.map((impianto) => mapToFacilityReport(impianto)),
        pagination: dto.paginationData ? mapToPagination(dto.paginationData) : undefined,
    }
}

export { mapToFacilityReports, mapToReportImpiantiDTO }
